import { Routes } from '@angular/router';
import { ROUTES_NAME } from './models/routes-name';
import { LoginGuard } from './auth/login.guard';
import { sugarContextResolver } from './resolvers/sugar-context.resolver';
import { sugarContextGuard } from './guards/sugar-context.guard';

export const routes: Routes = [
	{
		path: ROUTES_NAME.HOME,
		canActivate: [LoginGuard],
		loadComponent: () => import('./components/main/main.component').then((m) => m.MainComponent),
		children: [
			{
				path: ROUTES_NAME.HOME,
				loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
			},
			{
				path: 'quotation-list',
				redirectTo: '',
			},
			{
				path: ROUTES_NAME.QUOTATION,
				children: [
					{
						path: 'new',
						canActivate: [sugarContextGuard],
						resolve: { sugarContext: sugarContextResolver },
						loadComponent: () => import('./pages/new-quotation/new-quotation.component').then((x) => x.NewQuotationComponent),
					},
				],
			},
			{
				path: ROUTES_NAME.QUOTATION_DETAIL + '/:id',
				loadComponent: () => import('./pages/quotation-detail/quotation-detail.component').then((x) => x.QuotationDetailComponent),
			},
		],
	},
	{
		path: ROUTES_NAME.LOGIN,
		loadComponent: () => import('./pages/login/login.component').then((x) => x.LoginComponent),
	},
];
